<template lang="pug">
v-container
  v-row
    v-col(cols="12")
      h1 Рабочий стол
    v-col(cols="12")
      admin-notifications(v-if="isAdmin")
      v-card(v-else outlined).pa-4
        .d-flex.mb-4
          p.title.mb-0.mr-auto Уведомления
          v-btn.mr-2(
            @click="is_read = 0"
            :color="!is_read ? 'success' : '' "
          ) Новые
          v-btn(
            @click="is_read = 1"
            :color="is_read ? 'success': '' "
          ) Архив

        v-skeleton-loader(v-if="loading" type="card")

        template(v-else-if="notifications.length")
          notification-wrapper(
            v-for="notification in notifications"
            :key="notification.id"
            :notification="notification"
            :loading-id="loadingRead"
            @read="readNotification"
          )
          v-pagination(
            v-if="pages > 1"
            color="info"
            v-model="page"
            :length="pages"
            :total-visible="7"
          )
        v-alert(v-else type="info" text).mb-0 Уведомления не найдены
    //- line-chart
    //- donut-chart
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import notificationService from '@/services/API/notification';
import mixinDateTime from '@/mixins/mixinDateTime';
import NotificationWrapper from './components/NotificationWrapper.vue';
import { getPagination } from '@/lib/pagination';
import LineChart from './components/LineChart.vue';
import { NOTIFICATION_TYPES } from '@/store/modules/notification';
import { CACHE_KEYS } from '@/store/modules/cache';
import DonutChart from './components/DonutChart.vue';
import AdminNotifications from './components/AdminNotifications.vue';

export default {
  components:{
    NotificationWrapper,
    LineChart,
    DonutChart,
    AdminNotifications,
  },
  mixins:[mixinDateTime],
  data() {
    return {
      page: 1,
      pages: 1,
      notifications: [],
      is_read: false,

      loading: false,
      loadingRead: null,
    };
  },
  computed:{
    ...mapGetters({
      'user':'auth/getUser',
      'isAdmin':'auth/isAdmin',
      'notification':'notification/notification',
    }),
  },
  watch:{
    is_read() {
      if (this.page === 1) this.fetchNotifications();
      this.page = 1;
    },
    page:{
      immediate:true,
      handler() {
        this.fetchNotifications();
      },
    },
    notification(v) {
      if (this.page === 1 && !this.is_read) {
        this.notifications.splice(0, 1, v);
      }
    },
  },
  methods:{
    ...mapActions({
      'loadToCache':'cache/loadToCache',
    }),
    getOwnerId({ data }) {
      return data.owner_id;
    },
    async fetchNotifications() {
      const params = {
        'page': this.page,
        'pages': this.pages,
        'search[is_read]': Number(this.is_read),
        'sort': '-id',
        'per-page': 5,
      };
      this.loading = true;
      try {
        const response = await notificationService.getAll(params);
        this.notifications = response.data.data;

        // Load tranfers users
        const ids = this.notifications.filter(({ type }) => type === NOTIFICATION_TYPES.TRANSFER).map(this.getOwnerId);
        await this.loadToCache({ key:CACHE_KEYS.users, ids });

        const { pages, page } = getPagination(response.headers);
        this.page = page;
        this.pages = pages;
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      } finally {
        this.loading = false;
      }
    },

    async readNotification(id) {
      this.loadingRead = id;

      await notificationService.read(id);

      this.notifications = this.notifications.map((notification) => {
        if (notification.id === id) notification.read_at = new Date();
        return notification;
      });

      this.loadingRead = null;
    },
  },
};
</script>

<style lang="scss" scoped>

.masonry {
    margin: 1.5em 0;
    padding: 0;
    -moz-column-gap: 1.5em;
    -webkit-column-gap: 1.5em;
    column-gap: 1.5em;
    font-size: .85em;
    column-count: 1;
}

.item {
    display: inline-block;
    margin: 0 0 1.5em;
    width: 100%;
}

@media only screen and (min-width: 700px) {
    .masonry {
        -moz-column-count: 2;
        -webkit-column-count: 2;
        column-count: 2;
    }
}

</style>
